import { BiDrink } from "react-icons/bi";
import { FaRegMap, FaShip } from "react-icons/fa";
import { GoNote } from "react-icons/go";
import { GrLocation } from "react-icons/gr";
import { IoBoat, IoDocumentOutline, IoPeopleOutline } from "react-icons/io5";
import {
  MdHolidayVillage,
  MdOutlineAssignment,
  MdOutlineCalendarToday,
  MdOutlineHistory,
  MdOutlineSpaceDashboard,
} from "react-icons/md";
import { RiFilterLine, RiSearch2Line } from "react-icons/ri";
import { SlPeople } from "react-icons/sl";
import { TbBeach } from "react-icons/tb";

let navBarOptions = [
  {
    value: "HOME",
    label: "Tableau De Bord",
    icon: <MdOutlineSpaceDashboard />,
    link: "/",
  },
  {
    value: "NOMENCLATURE",
    label: "Nomenclature",
    icon: <RiFilterLine />,
    link: "/nomenclature",
  },
  {
    value: "DAILY_STAFF_PRESENTATION",
    // label: "Équipe du jour",
    label: "Pointage",
    icon: <MdOutlineCalendarToday />,
    link: "/daily-staff-presentation",
  },
  {
    value: "EMPLOYEE_LIST",
    label: "Liste de présence",
    icon: <SlPeople />,
    link: "/presence-list",
  },

  {
    value: "SEARCH",
    label: "Recherche",
    icon: <RiSearch2Line />,
    link: "/search",
  },
  {
    value: "EMPLOYEES",
    label: "Employés",
    icon: <IoPeopleOutline />,
    link: "/employees",
  },
  {
    value: "SITES",
    label: "Sites",
    icon: <GrLocation />,
    link: "/sites",
  },
  {
    value: "FUNCTIONS",
    label: "Fonctions",
    icon: <IoDocumentOutline />,
    link: "/functions",
  },
  {
    value: "ROLES",
    label: "Roles",
    icon: <IoDocumentOutline />,
    link: "/roles",
  },
  {
    value: "ZONES",
    label: "Zones",
    icon: <FaRegMap />,
    link: "/zones",
  },
  {
    value: "COMMENTS",
    label: "Commentaires",
    icon: <GoNote />,
    link: "/comments",
  },

  //AbsenceListPage
  {
    value: "ABSENCES",
    label: "Absences",
    icon: <MdOutlineAssignment />,
    link: "/absences",
  },
  {
    value: "VACATIONS",
    label: "Conges",
    icon: <TbBeach />,
    link: "/vacations",
  },
  {
    value: "ACTIVITY",
    label: "Activités",
    icon: <MdOutlineHistory />,
    link: "/user-activities",
  },
];

export default navBarOptions;
